import { useState } from 'react';

import { useLlamaSwap } from '@/app/components/LlamaSwap/useLlamaSwap';
import {
  SWAP_DEPOSIT_SECTIONS,
  useUsdcSwapDepositSequential,
} from '@/app/components/VaultsItemPageComponents/hooks/useUsdcSwapDepositSequential';
import { VaultTrancheId } from '@/app/shared/constants/vaults';

type UseUsdcSwapDepositParams = {
  usdcAmount: string;
  slippage: string;
  trancheId: VaultTrancheId;
  vaultId?: string;
  trancheSymbol?: string;
  chain?: string;
};

export const useUsdcSwapDeposit = ({
  usdcAmount,
  slippage,
  trancheId,
  vaultId,
  trancheSymbol,
  chain = 'ethereum',
}: UseUsdcSwapDepositParams) => {
  const [completedWyldsAmount, setCompletedWyldsAmount] = useState('');

  const swap = useLlamaSwap({
    amount: usdcAmount,
    slippage,
    chain,
  });

  const sequential = useUsdcSwapDepositSequential({
    usdcAmount,
    quote: swap.activeQuote,
    refetchSwapAllowance: swap.refetchAllowance,
    trancheId,
    vaultId,
    trancheSymbol,
    providerLabel: swap.providerLabel,
    enabled: !!swap.activeQuote,
    onSwapComplete: setCompletedWyldsAmount,
  });

  return {
    buyAmount: swap.buyAmount,
    rate: swap.rate,
    minReceived: swap.minReceived,
    priceImpact: swap.priceImpact,
    sellUsd: swap.sellUsd,
    buyUsd: swap.buyUsd,
    providerLabel: swap.providerLabel,
    needsApproval: swap.needsApproval,
    isLoadingQuote: swap.isLoadingQuote,
    isQuoteFetching: swap.isQuoteFetching,
    dataUpdatedAt: swap.dataUpdatedAt,
    showQuoteError: swap.showQuoteError,
    quoteError: swap.quoteError,
    activeQuote: swap.activeQuote,
    completedWyldsAmount,
    sections: SWAP_DEPOSIT_SECTIONS,
    steps: sequential.steps,
    handleSend: sequential.handleSend,
    resetTransactionState: sequential.resetTransactionState,
    errorMessage: sequential.errorMessage,
    isUserRejectedError: sequential.isUserRejectedError,
    isRunning: sequential.isRunning,
    isComplete: sequential.isComplete,
    isSequentialReady: sequential.isReady,
    supportsBatching: sequential.supportsBatching,
    swapSkipped: sequential.swapSkipped,
  };
};
